import { IconProps } from "@chakra-ui/react";
import { AirplaneRight } from "@airhelp/icons";
import { appSettingsSnapshot } from "v2/settings";
import { isRtl } from "utils/getLocaleDirection";

export function AirplaneIcon(props: IconProps) {
  const { locale } = appSettingsSnapshot();
  return <AirplaneRight {...props} transform={isRtl(locale) ? "rotate(180deg)" : ""} />;
}
